/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Camera_UnavailableInputs */

const en_us2_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The camera couldn't be opened on this device.`)
};

const pt_br2_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para abrir a câmera neste aparelho.`)
};

const es_419_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo abrir la cámara en este dispositivo.`)
};

const pt_pt2_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível abrir a câmara neste dispositivo.`)
};

const fr_fr2_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'ouvrir la caméra sur cet appareil.`)
};

const de_de2_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Kamera ließ sich auf diesem Gerät nicht öffnen.`)
};

const it_it2_body_assessment_camera_unavailable = /** @type {(inputs: Body_Assessment_Camera_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile aprire la fotocamera su questo dispositivo.`)
};

/**
* | output |
* | --- |
* | "The camera couldn't be opened on this device." |
*
* @param {Body_Assessment_Camera_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_camera_unavailable = /** @type {((inputs?: Body_Assessment_Camera_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Camera_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_camera_unavailable(inputs)
	if (locale === "es-419") return es_419_body_assessment_camera_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_camera_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_camera_unavailable(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_camera_unavailable(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_camera_unavailable(inputs)
	return en_us2_body_assessment_camera_unavailable(inputs)
});
export { body_assessment_camera_unavailable as "body-assessment.camera_unavailable" }